<template>
  <section class="skuSp-manage">
    <Card>
      <Form ref="searchForm" :model="searchForm" inline :label-width="0">
        <Row>
          <FormItem prop="categoryCode">
            <Select
              filterable
              v-model="searchForm.categoryCode"
              placeholder="请选择分类"
              style="width: 130px"
            >
              <Option
                :key="index"
                :value="item.code"
                v-for="(item, index) in categoryAllList"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <FormItem prop="brandCode">
            <Select
              filterable
              v-model="searchForm.brandCode"
              placeholder="请选择品牌"
              style="width: 130px"
            >
              <Option
                :key="index"
                :value="item.code"
                v-for="(item, index) in brandAllList"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem prop="name">
            <Input
              v-model="searchForm.name"
              placeholder="请输入名称"
              style="width: 300px"
            ></Input>
          </FormItem>
          <FormItem style="margin-left: 15px" class="br">
            <Button @click="handleSearch" type="primary" icon="ios-search"
              >搜索</Button
            >
            <Button @click="handleReset" style="margin-left: 10px">重置</Button>
          </FormItem>
        </Row>
      </Form>

      <Table
        :loading="loading"
        border
        :columns="columns"
        :data="dataSource"
        ref="table"
      ></Table>

      <Row type="flex" justify="end" class="page" style="margin-top: 10px">
        <Page
          :current="searchForm.page"
          :total="total"
          :page-size="searchForm.pageSize"
          @on-change="changePage"
          @on-page-size-change="changePageSize"
          :page-size-opts="[10, 20, 50]"
          size="small"
          show-total
          show-elevator
          show-sizer
        >
        </Page>
      </Row>
    </Card>
  </section>
</template>

<script>
export default {
  name: "skuForm",
  props: {
    skuCode: {
      type: String
    },
    handleSelectCheck: {
      type: Function
    }
  },
  data() {
    return {
      brandAllList:[],
      total: 0,
      drop: false,
      loading: false,
      dataSource: [],
      baseRetailerTypeList: [],
      spInfoQueryList: [],
      categoryAllList: [],
      searchForm: {
        page: 1,
        pageSize: 10,
        categoryCode: "",
        brandCode: "",
        name: ""
      },
      columns: [
        {
          title: "选中",
          align: "center",
          key: "checkBox",
          minWidth: 50,
          render: (h, params) => {
            return h("div", [
              h("Checkbox", {
                props: {
                  value: params.row.checkBox
                },
                on: {
                  "on-change": e => {
                    this.dataSource.forEach(items => {
                      this.$set(items, "checkBox", false);
                    });
                    this.dataSource[params.index].checkBox = e;
                    this.handleSelectCheck(params.row);
                  }
                }
              })
            ]);
          }
        },
        {
          title: "基础编码",
          key: "code",
          minWidth: 80,
          align: "center"
        },
        {
          title: "名称",
          key: "name",
          minWidth: 120,
          align: "center"
        },
        {
          title: "分类",
          key: "categoryName",
          minWidth: 120,
          align: "center"
        },
        {
          title: "品牌",
          key: "brandName",
          minWidth: 100,
          align: "skuCode"
        },
        {
          title: "添加人",
          key: "addOptUser",
          minWidth: 100,
          align: "center"
        }
      ]
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getBrandAll();
      this.getCategoryAll();
      this.getProductSkuQueryAll();
    },
    async getBrandAll() {
      const { data } = await this.$api["brandAll"]({});
      this.brandAllList = data;
    },
    async getProductSkuQueryAll(params = {}) {
      const { data, total } = await this.$api["productSkuQueryAll"](params);
      if (this.skuCode) {
        const checkedData = data.reduce((prev, cuur) => {
          return prev.concat(
            cuur.code == this.skuCode ? { ...cuur, checkBox: true } : cuur
          );
        }, []);
        this.dataSource = checkedData;
        this.total = total;
      } else {
        this.dataSource = data;
        this.total = total;
      }
    },
    async getCategoryAll() {
      const { data } = await this.$api["categoryAll"]({});
      this.categoryAllList = data;
    },
    handleSearch() {
      this.searchForm.page = 1;
      this.searchForm.pageSize = 10;

      const params = {
        ...this.searchForm
      };
      this.getProductSkuQueryAll(params);
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.page = 1;
      this.searchForm.pageSize = 10;

      this.searchForm.categoryCode = "";
      this.searchForm.brandCode = "";
      this.searchForm.name = "";
      this.getProductSkuQueryAll();
    },
    handleOpenDeatil(v) {
      this.$router.push({
        path: "detail",
        query: {
          retCode: v
        }
      });
    },
    changePage(v) {
      this.searchForm.page = v;
      this.getProductSkuQueryAll(this.searchForm);
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getProductSkuQueryAll(this.searchForm);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/commodity/components/skuForm.vue